import { Box, Button, Link, Typography } from '@mui/material';

const stripePortalLoginUrl =
  (import.meta.env.VITE_STRIPE_BILLING_PORTAL_LOGIN_URL as string | undefined)?.trim() ?? '';

const billingPortalHref = stripePortalLoginUrl || '/admin/users';

export const SuspendedPage = ({ scheduledDeletion }: { scheduledDeletion?: string | null }) => {
  const retainUntil = scheduledDeletion
    ? new Date(scheduledDeletion).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    : null;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
        textAlign: 'center',
        p: 4,
        backgroundColor: 'background.default',
      }}
    >
      <Typography variant="h4" gutterBottom fontWeight={700}>
        Account Suspended
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 1, maxWidth: 480 }}>
        Your account has been suspended.
        {retainUntil && (
          <> Your data will be retained until <strong>{retainUntil}</strong>.</>
        )}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 480 }}>
        To reactivate your account, please subscribe again using the billing portal.
      </Typography>
      <Button
        variant="contained"
        size="large"
        component={Link}
        href={billingPortalHref}
        target={stripePortalLoginUrl ? '_blank' : '_self'}
        rel="noopener noreferrer"
      >
        Go to Billing Portal
      </Button>
    </Box>
  );
};
